import type { AppLocale } from "./locale";

export class BotAccessApiError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
  ) {
    super(code);
  }
}

async function responseBody(response: Response): Promise<Record<string, unknown>> {
  try {
    return (await response.json()) as Record<string, unknown>;
  } catch {
    return {};
  }
}

export async function loadBotAccessStatus(initData: string): Promise<boolean> {
  const response = await fetch("/api/bot-access/status", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ initData }),
  });
  const body = await responseBody(response);
  if (!response.ok) {
    throw new BotAccessApiError(
      response.status,
      typeof body.error === "string" ? body.error : "bot_access_status_failed",
    );
  }
  return body.connected === true;
}

export async function connectBotAccess(
  initData: string,
  locale: AppLocale,
): Promise<void> {
  const response = await fetch("/api/bot-access/connect", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ initData, locale }),
  });
  const body = await responseBody(response);
  if (!response.ok || body.connected !== true) {
    throw new BotAccessApiError(
      response.status,
      typeof body.error === "string" ? body.error : "bot_access_connect_failed",
    );
  }
}
